import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** オンバランス */
enum OnBalance {
  onBalance = '1',
  offBalance = '2',
}

const nameConfig = {
  onBalance: new Map([
    [Locale.ja, 'オンバランス'],
    [Locale.en, 'On Balance'],
  ]),
  offBalance: new Map([
    [Locale.ja, 'オフバランス'],
    [Locale.en, 'Off Balance'],
  ]),
};

const toEnum = rawValueToEnum(OnBalance, OnBalance.onBalance);
const toDisplay = enumToName(OnBalance, nameConfig);
const toDisplayWithPrefix = enumToName(OnBalance, nameConfig, { prefix: true });

export const onBalance = {
  enum: OnBalance,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { OnBalance };
